document.addEventListener("DOMContentLoaded", async function () {
  const params = new URLSearchParams(window.location.search);

  const handle = params.get("first");
  const variantId = params.get("variant");
  const limit = parseInt(params.get("limit"), 10) || 24;

  if (!handle) return;

  const grid = document.querySelector("#product-grid");
  if (!grid) return;

  // Find pinned product if it already exists
  let pinnedItem = Array.from(grid.children).find(item =>
    item.querySelector(`a[href*="/products/${handle}"]`)
  );

  /* --------------------------------------------------
     IF NOT FOUND, FETCH PRODUCT CARD HTML
  -------------------------------------------------- */
  if (!pinnedItem) {
    try {
      const res = await fetch(`/products/${handle}?view=card`);
      if (!res.ok) return;

      const html = await res.text();
      if (!html.trim()) return;

      grid.insertAdjacentHTML("afterbegin", html);
      pinnedItem = grid.firstElementChild;

      // Set aspect ratio to 125%
      const ratioEl = pinnedItem.querySelector(".card__inner.ratio");
      if (ratioEl) ratioEl.style.setProperty("--ratio-percent", "125%");

      // Force Loox to render dynamic reviews
      (function waitForLoox(retries = 20) {
        if (window.Loox && typeof window.Loox.renderRatingWidgets === "function") {
          window.Loox.renderRatingWidgets();
        } else if (retries > 0) {
          setTimeout(() => waitForLoox(retries - 1), 500);
        }
      })();

    } catch {
      return;
    }
  } else {
    grid.prepend(pinnedItem);

    // Ensure aspect ratio is correct
    const ratioEl = pinnedItem.querySelector(".card__inner.ratio");
    if (ratioEl) ratioEl.style.setProperty("--ratio-percent", "125%");
  }

  /* --------------------------------------------------
     REMOVE DUPLICATES
  -------------------------------------------------- */
  Array.from(grid.children).forEach(item => {
    if (
      item !== pinnedItem &&
      item.querySelector(`a[href*="/products/${handle}"]`)
    ) {
      item.remove();
    }
  });

  /* --------------------------------------------------
     ENFORCE LIMIT
  -------------------------------------------------- */
  Array.from(grid.children).slice(limit).forEach(el => el.remove());

  /* --------------------------------------------------
     VARIANT IMAGE + LINKS
  -------------------------------------------------- */
  if (variantId) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      const variant = product.variants.find(
        v => String(v.id) === String(variantId)
      );
      if (variant && variant.featured_image) {
        const img = pinnedItem.querySelector("img");
        if (img) {
          // Replace image with variant image
          img.src = variant.featured_image.src;
          img.srcset = "";
        }
      }

      // Update all links to carry the variant
      pinnedItem.querySelectorAll("a[href]").forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set("variant", variantId);
        link.href = url.toString();
      });

    } catch {}
  }
});
